<template>
  <UButton
    v-if="props.rank === Ranks.Entry"
    color="neutral"
    :variant="active ? 'subtle' : 'outline'"
    class="capitalize"
    @click="handleClickRank"
  >
    {{ rank }}
  </UButton>
  <UButton
    v-else-if="props.rank === Ranks.Junior"
    color="info"
    :variant="active ? 'subtle' : 'outline'"
    class="capitalize"
    @click="handleClickRank"
  >
    {{ rank }}
  </UButton>
  <UButton
    v-else-if="props.rank === Ranks.Middle"
    color="warning"
    :variant="active ? 'subtle' : 'outline'"
    class="capitalize"
    @click="handleClickRank"
  >
    {{ rank }}
  </UButton>
  <UButton
    v-else-if="props.rank === Ranks.Senior"
    color="error"
    :variant="active ? 'subtle' : 'outline'"
    class="capitalize"
    @click="handleClickRank"
  >
    {{ rank }}
  </UButton>
  <UButton
    v-else
    color="secondary"
    :variant="active ? 'subtle' : 'outline'"
    class="capitalize"
    @click="handleClickRank"
  >
    {{ rank }}
  </UButton>
</template>

<script lang="ts" setup>
import Ranks from "@/constants/ranks";

const props = defineProps({
  rank: {
    type: String,
    validator(value) {
      return Object.values(Ranks).includes(value as string);
    },
    default: "entry",
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  isQuestion: {
    type: Boolean,
    default: false,
  },
});

const active = ref(false);
const router = useRouter();
const route = useRoute();

const handleClickRank = () => {
  if (props.isQuestion === true) {
    return;
  }
  active.value = !active.value;
  let ranks = (route.query?.ranks as string)?.split(",") ?? [];
  if (!ranks?.includes(props.rank.toLowerCase())) {
    ranks.push(props.rank);
  } else {
    ranks = ranks.filter((item) => item !== props.rank.toLowerCase());
  }
  router.push({
    query: Object.assign({}, route.query, {
      ranks: ranks
        ?.filter((item) => !!item)
        .join(",")
        .toLowerCase(),
    }),
  });
};

onMounted(() => {
  const ranks = (route.query?.ranks as string)?.split(",") ?? [];
  if (ranks?.includes(props.rank.toLowerCase())) {
    active.value = true;
  }
  if (props.isActive === true) {
    active.value = true;
  }
});
</script>
